import { render } from "./AllergyForm.vue?vue&type=template&id=57be6b38&scoped=true"
import script from "./AllergyForm.vue?vue&type=script&lang=js"
export * from "./AllergyForm.vue?vue&type=script&lang=js"

import "./AllergyForm.vue?vue&type=style&index=0&id=57be6b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57be6b38"]])

export default __exports__